import type { BayHireRequest } from "@services/bayHireApi";
import { formatBaySize } from "../components/BayHireRequestDetail/BayInformationCard";

// DFT-0044 slice V (F1): resubmit, update, and renew all prefill bayAssignments from an existing
// request's own snapshots the same way (no extra Reference Data lookup), so this stays a single
// source of truth for that mapping.
export const bayAssignmentsInitialValue = (
  request: Pick<BayHireRequest, "bayAssignments"> | null,
) =>
  (request?.bayAssignments ?? []).map((bay) => ({
    referenceDataBayId: bay.referenceDataBayId,
    bayNoSnapshot: bay.bayNoSnapshot ?? undefined,
    sizeLabel: formatBaySize(bay.criteriaSnapshot),
  }));
